import { BaseMarkerFactory } from '../../../../_shared/interfaces/maps/base-marker-factory';

export class WorkshopMarkerFactory extends BaseMarkerFactory {
  protected override createMarkerDiv(data: any): HTMLDivElement {
    const markerDiv = document.createElement('div');
    const color = '#EE2737';

    markerDiv.className = 'marker-pulsate';
    markerDiv.style.setProperty('--cluster-color', color);
    markerDiv.style.position = 'relative';
    markerDiv.style.width = '32px';
    markerDiv.style.height = '32px';
    markerDiv.dataset['type'] = 'default';

    markerDiv.innerHTML = `
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="${color}"/>
        <path d="M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19ZM16 14.5C16.8284 14.5 17.5 15.1716 17.5 16C17.5 16.8284 16.8284 17.5 16 17.5C15.1716 17.5 14.5 16.8284 14.5 16C14.5 15.1716 15.1716 14.5 16 14.5Z" fill="white"/>
        <path d="M15.565 24.3605C15.6955 24.4535 15.8478 24.5 16 24.5C16.1523 24.5 16.3045 24.4535 16.435 24.3605C16.663 24.1993 22.0218 20.33 22 16C22 12.6918 19.3083 10 16 10C12.6917 10 9.99998 12.6918 9.99998 15.4963C9.97823 20.33 15.337 24.1993 15.565 24.3605ZM16 11.5C18.4818 11.5 20.5 13.5183 20.5 16.0038C20.5158 19.3323 17.209 22.32 16 23.3013C14.7918 22.3203 11.4843 19.3308 11.5 16C11.5 13.5183 13.5183 11.5 16 11.5Z" fill="white"/>
      </svg>`;

    return markerDiv;
  }

  protected override createTitle(data: any): string {
    return data.name ?? '';
  }
}